const header = $('body.edac-theme .main-header')
const preHeader = $('body.edac-theme .pre-header')
if (window.scrollY == 0) {
    header.addClass('transparent')
    preHeader.addClass('transparent')
}

$(window).on('scroll', function (e) {
    if ($(this).scrollTop() > 60) {
        header.css('transition', 'all 0.3s ease')
        preHeader.css('transition', 'all 0.3s ease')
        header.removeClass('transparent')
        preHeader.removeClass('transparent')
    } else {
        header.css('transition', 'all 0.3s ease')
        preHeader.css('transition', 'all 0.3s ease')
        header.addClass('transparent')
        preHeader.addClass('transparent')
    }

    if ($(this).scrollTop() > 200) {
        $('.sticky-box-main').css({
            'display': 'none',
        });
    }

});

// import 'jquery';
import 'slick-carousel';
import './vueApp';

// import maps from './util/maps';
import blocks from './blocks/gutenberg-blocks';

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

// maps()
blocks()

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());





// WEBPACK FOOTER //
// ./scripts/main.js